import React, { lazy, Component } from 'react';
import { ArrowRight } from 'lucide-react';
// ============================================
// TEXTOS EDITABLES - Modifica estos textos directamente
// ============================================
const SECTION_TITLE = 'Proyectos que Hablan por Sí Mismos';
const SECTION_SUBTITLE = 'Transformaciones reales que superaron las expectativas de nuestros clientes';
const BEFORE_LABEL = 'ANTES';
const AFTER_LABEL = 'DESPUÉS';
const BUTTON_TEXT = 'Ver Portafolio Completo';
// ============================================
// PROYECTOS - Modifica solo 3 proyectos (ANTES y DESPUÉS)
// ============================================
const projects = [{
  before: 'https://cdn.magicpatterns.com/uploads/4QQMFF9bewmxSTQy3wcUe7/GERFAJ_-_CH_-_ANTES.webp',
  after: 'https://cdn.magicpatterns.com/uploads/eyF3wf7NaCMfZNudfahter/GERFAJ_-_CH_-_001.webp',
  city: 'Bucaramanga',
  zone: 'Campo Hermoso',
  type: 'Residencial'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/o2wosNKeSEHRzNehPRAi1q/GERFAJ_-_ANTES_-_SONESTA_.webp',
  after: 'https://cdn.magicpatterns.com/uploads/u18adFRKUZsVfX9djiVTFJ/GERFAJ_-_SONESTA_-_DESPUES.webp',
  city: 'Floridablanca',
  zone: 'Caracolí',
  type: 'Comercial'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/vPaL3FNrgQjkgFi5ckv8nV/GERFAJ_-_JIMFER_-_ANTES.webp',
  after: 'https://cdn.magicpatterns.com/uploads/u18adFRKUZsVfX9djiVTFJ/GERFAJ_-_SONESTA_-_DESPUES.webp',
  city: 'Bucaramanga',
  zone: 'San Alonso',
  type: 'Corporativo'
}];
export function PortfolioSection() {
  const handleScrollToForm = () => {
    const formSection = document.getElementById('offer');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => {
        const firstInput = document.getElementById('nombre');
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };
  return <section className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-260">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-261">
        <div className="text-center mb-8 md:mb-16" data-id="element-262">
          <h2 className="text-[26px] md:text-[40px] font-bold text-[#1A1A1A] mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-263">
            {SECTION_TITLE}
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal max-w-2xl mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-264">
            {SECTION_SUBTITLE}
          </p>
        </div>

        <div className="space-y-8 md:space-y-16 mb-8 md:mb-12" data-id="element-265">
          {projects.map((project, index) => <div key={index} className="space-y-4" data-id="element-266">
              {/* Before/After Images */}
              <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-267">
                {/* ANTES */}
                <div className="group" data-id="element-268">
                  <div className="relative rounded-3xl overflow-hidden aspect-[4/3]" data-id="element-269">
                    <img src={project.before} alt={`${project.city} - ${project.zone} - Antes`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" width={364} height={273} sizes="(max-width: 768px) 364px, 534px" loading="lazy" decoding="async" data-id="element-270" />
                    <div className="absolute top-4 left-4 bg-[#6B7280] text-white px-4 py-2 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
                  lineHeight: '1',
                  letterSpacing: '0.08em'
                }} data-id="element-271">
                      {BEFORE_LABEL}
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-transparent to-transparent opacity-60" data-id="element-272" />
                  </div>
                </div>

                {/* DESPUÉS */}
                <div className="group" data-id="element-273">
                  <div className="relative rounded-3xl overflow-hidden aspect-[4/3]" data-id="element-274">
                    <img src={project.after} alt={`${project.city} - ${project.zone} - Después`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" width={364} height={273} sizes="(max-width: 768px) 364px, 534px" loading="lazy" decoding="async" data-id="element-275" />
                    <div className="absolute top-4 left-4 bg-[#E8621A] text-white px-4 py-2 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
                  lineHeight: '1',
                  letterSpacing: '0.08em'
                }} data-id="element-276">
                      {AFTER_LABEL}
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-transparent to-transparent opacity-60" data-id="element-277" />
                  </div>
                </div>
              </div>

              {/* Shared Caption */}
              <div className="text-center space-y-2" data-id="element-278">
                <div className="flex items-center justify-center gap-2 text-[#1A1A1A]/60 text-[15px] md:text-[17px] font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-279">
                  <span data-id="element-280">{project.city}</span>
                  <span data-id="element-281">•</span>
                  <span data-id="element-282">{project.zone}</span>
                </div>
                <div className="inline-block bg-[#1A1A1A]/10 text-[#1A1A1A] px-3 py-1 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-283">
                  {project.type}
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-284">
          <button onClick={handleScrollToForm} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-10 py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-2xl shadow-[#E8621A]/30 hover:scale-105 inline-flex items-center justify-center gap-3 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-285">
            AGENDAR ASESORÍA - GRATIS
          </button>
        </div>
      </div>
    </section>;
}